document.documentElement.classList.add('js');

(function () {
  var variantsScript = document.getElementById('ProductVariantsJson');
  var form = document.getElementById('ProductForm');
  if (!variantsScript || !form) return;

  var variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent || '[]');
  } catch (error) {
    return;
  }

  var optionSelects = Array.prototype.slice.call(document.querySelectorAll('.variant-select'));
  var variantIdInput = document.getElementById('VariantId');
  var priceEl = document.getElementById('ProductPrice');
  var stockEl = document.getElementById('VariantStock');
  var button = document.getElementById('AddToCartButton');
  var productImage = document.getElementById('ProductImage');

  function formatMoney(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '$' + amount.replace(/\.00$/, '');
  }

  function getSelectedOptions() {
    return optionSelects.map(function (select) {
      return select.value;
    });
  }

  function findMatchingVariant(selectedOptions) {
    return variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  }

  function updateProduct() {
    var selectedOptions = getSelectedOptions();
    var variant = findMatchingVariant(selectedOptions);

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.textContent = 'Unavailable';
      }
      if (stockEl) stockEl.textContent = 'Unavailable';
      return;
    }

    if (variantIdInput) variantIdInput.value = variant.id;
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    if (button) {
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    if (stockEl) stockEl.textContent = variant.available ? 'Available' : 'Sold out';

    if (variant.featured_image && variant.featured_image.src && productImage) {
      productImage.src = variant.featured_image.src;
      productImage.alt = variant.featured_image.alt || productImage.alt;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  optionSelects.forEach(function (select) {
    select.addEventListener('change', updateProduct);
  });

  updateProduct();
})();
